<script setup lang="ts">
import { computed } from 'vue'
import { useImageFallback } from '@/composables/useImageFallback'
import { initialOf, kidColorFor, type KidColor } from './fbUi'

const props = withDefaults(defineProps<{
  name: string
  userId: string
  imageUrl?: string | null
  color?: KidColor
  size?: number
  ring?: boolean
}>(), {
  size: 40,
})

const { failed: avatarFailed, onError: handleAvatarError } = useImageFallback(
  computed(() => props.imageUrl ?? null),
)
const showImage = computed(() => !!props.imageUrl && !avatarFailed.value)
</script>

<template>
  <v-avatar
    :size="size"
    class="fb-kid-avatar"
    :class="[
      `fb-kid-avatar--${color ?? kidColorFor(userId)}`,
      { 'fb-kid-avatar--ring': ring },
    ]"
    :role="showImage ? undefined : 'img'"
    :aria-label="showImage ? undefined : name.trim() ? name : 'Family member'"
  >
    <v-img
      v-if="showImage"
      :src="imageUrl ?? undefined"
      :alt="name"
      cover
      @error="handleAvatarError"
    />
    <template v-else>{{ initialOf(name) }}</template>
  </v-avatar>
</template>
